import { Auth, API } from 'aws-amplify';
import axios from 'axios';
import { vuexErrorHandler } from '@switchsystems/coactive-vue-lib';
import RecruitmentJobOffer from '@switchsystems/coactive-node-api-recruitment-shared/src/constants/RecruitmentJobOffer';
import RecruitmentJobApplication from '@switchsystems/coactive-node-api-recruitment-shared/src/constants/RecruitmentJobApplication';

const API_NAME = 'recruitment';
const API_VERSION = '/v1';
const CONTENT_TYPE_JOBOFFER = 'application/vnd.coactive.recruitment.job-offer+json';

async function getApiInit() {
  return {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
    },
  };
}

const modulestate = () => ({
  blankDbsDeclaration: RecruitmentJobApplication.blankDbsDeclaration,
  blankMedicalQuestionnaire: RecruitmentJobOffer.blankMedicalQuestionnaire,
  blankMedicalQuestionnaireNights: RecruitmentJobOffer.blankMedicalQuestionnaireNights,
});
const getters = {
  blankDbsDeclaration: (state) => state.blankDbsDeclaration,
  blankMedicalQuestionnaire: (state) => state.blankMedicalQuestionnaire,
  blankMedicalQuestionnaireNights: (state) => state.blankMedicalQuestionnaireNights,
};

const mutations = {
};
const actions = {
  async fetchJobApplications(context, payload) {
    const myInit = await getApiInit();

    // payload contains filter/sort/pagination options.
    if (payload) {
      myInit.queryStringParameters = {
        page: payload.page,
        pageSize: payload.pageSize,
      };
    }

    return API.get(API_NAME, `${API_VERSION}/job-applications/`, myInit)
      .then((response) => response)
      .catch((error) => vuexErrorHandler(error));
  },
  async fetchJobApplication(context, params) {
    const myInit = await getApiInit();
    return API.get(API_NAME, `${API_VERSION}/job-applications/${params.ref}`, myInit)
      .then((response) => response)
      .catch((error) => vuexErrorHandler(error));
  },
  async applyForJobOpportunity(context, jobOpportunityId) {
    const myInit = await getApiInit().catch((error) => { vuexErrorHandler(error); throw error; });
    myInit.body = { jobOpportunityId };

    return API.post(API_NAME, `${API_VERSION}/job-applications`, myInit)
      .then((response) => response);
  },
  async fetchJobOffer(context, params) {
    const myInit = await getApiInit().catch((error) => { vuexErrorHandler(error); throw error; });
    return API.get(API_NAME, `${API_VERSION}/job-offers/${params.id}`, myInit)
      .then((response) => response)
      .catch((error) => vuexErrorHandler(error));
  },
  async acceptJobOffer(context, params) {
    const myInit = await getApiInit().catch((error) => { vuexErrorHandler(error); throw error; });
    return API.post(
      API_NAME,
      `${API_VERSION}/job-offers/${params.jobOffer.id}/accept`,
      myInit,
    ).then((response) => response);
  },
  async declineJobOffer(context, params) {
    const myInit = await getApiInit().catch((error) => { vuexErrorHandler(error); throw error; });
    return API.post(
      API_NAME,
      `${API_VERSION}/job-offers/${params.jobOffer.id}/decline`,
      myInit,
    ).then((response) => response);
  },
  async updateJobOffer(context, params) {
    const myInit = await getApiInit().catch((error) => { vuexErrorHandler(error); throw error; });

    myInit.headers.Accept = CONTENT_TYPE_JOBOFFER;
    myInit.body = params.changes;
    myInit.body.jobApplicationId = params.jobOffer.jobApplicationId;
    myInit.body.jobOpportunityId = params.jobOffer.jobOpportunityId;
    myInit.body.userId = params.jobOffer.userId;

    return API.patch(API_NAME, `${API_VERSION}/job-offers/${params.jobOffer.id}`, myInit)
      .then((response) => response);
  },
  async submitJobApplication(context, params) {
    const myInit = await getApiInit().catch((error) => { vuexErrorHandler(error); throw error; });
    myInit.body = params.jobApplication;

    return API.post(API_NAME, `${API_VERSION}/job-applications/${params.id}/submit`, myInit)
      .then((response) => response);
  },
  async updateJobApplication(context, params) {
    const myInit = await getApiInit().catch((error) => { vuexErrorHandler(error); throw error; });
    myInit.body = params.jobApplication;

    return API.patch(API_NAME, `${API_VERSION}/job-applications/${params.id}`, myInit)
      .then((response) => response);
  },
  async withdrawJobApplication(context, jobApplication) {
    const myInit = await getApiInit().catch((error) => { vuexErrorHandler(error); throw error; });
    return API.post(
      API_NAME,
      `${API_VERSION}/job-applications/${jobApplication.id}/withdraw`,
      myInit,
    ).then((response) => response);
  },
  async deleteJobApplication(context, jobApplication) {
    const myInit = await getApiInit().catch((error) => { vuexErrorHandler(error); throw error; });
    return API.del(
      API_NAME,
      `${API_VERSION}/job-applications/${jobApplication.id}`,
      myInit,
    ).then((response) => response);
  },
  async uploadCvFile(context, params) {
    const myInit = await getApiInit().catch((error) => { vuexErrorHandler(error); throw error; });
    myInit.body = {
      filename: params.file.name,
      type: 'cv',
    };
    // generate the pre-signed url and file id for the upload
    const uploadDetails = await API.post(
      API_NAME,
      `${API_VERSION}/job-applications/${params.entityId}/upload`,
      myInit,
    );
    // upload the file (plain axios request this is to aws s3 api)
    const uploadResult = await axios.put(uploadDetails.httpPutUrl, params.file);
    return {
      fileId: uploadDetails.fileId,
      uploadHttpStatus: uploadResult.status,
    };
  },
  async deleteCvFile(context, params) {
    const myInit = await getApiInit().catch((error) => { vuexErrorHandler(error); throw error; });
    return API.del(
      API_NAME,
      `${API_VERSION}/job-applications/${params.entityId}/files/${params.fileId}`,
      myInit,
    );
  },
  async pinLogin(context, pin) {
    return API.get(
      API_NAME,
      `${API_VERSION}/users/login-pin/${pin}`,
    );
  },
};

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state: modulestate,
};
